/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageLastCheckedAtQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type PageLastCheckedAtQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly isPrioritized: boolean, readonly lastCheckedAt: CK.Timestamp | null } | null };


export const PageLastCheckedAtDocument = gql`
    query PageLastCheckedAt($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    isPrioritized
    lastCheckedAt
  }
}
    `;

/**
 * __usePageLastCheckedAtQuery__
 *
 * To run a query within a React component, call `usePageLastCheckedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageLastCheckedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageLastCheckedAtQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePageLastCheckedAtQuery(baseOptions: Apollo.QueryHookOptions<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables> & ({ variables: PageLastCheckedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables>(PageLastCheckedAtDocument, options);
      }
export function usePageLastCheckedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables>(PageLastCheckedAtDocument, options);
        }
export function usePageLastCheckedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables>(PageLastCheckedAtDocument, options);
        }
export type PageLastCheckedAtQueryHookResult = ReturnType<typeof usePageLastCheckedAtQuery>;
export type PageLastCheckedAtLazyQueryHookResult = ReturnType<typeof usePageLastCheckedAtLazyQuery>;
export type PageLastCheckedAtSuspenseQueryHookResult = ReturnType<typeof usePageLastCheckedAtSuspenseQuery>;
export type PageLastCheckedAtQueryResult = Apollo.QueryResult<PageLastCheckedAtQuery, PageLastCheckedAtQueryVariables>;